// // import React, { useState } from 'react';
// // import axios from 'axios';
// // import { useNavigate, Link } from 'react-router-dom';

// // export default function Login() {
// //   const [email, setEmail] = useState('');
// //   const [password, setPassword] = useState('');
// //   const navigate = useNavigate();

// //   const submit = async (e) => {
// //     e.preventDefault();
// //     try {
// //       const res = await axios.post('https://grocerrybackend.vercel.app/api/admin/login', { email, password });
// //       // backend returns { token, role, name } per the admin-only backend spec
// //       if (!res.data || !res.data.token) {
// //         alert('Login failed: Invalid response from server');
// //         return;
// //       }
// //       if (res.data.role !== 'admin') {
// //         alert('Access Denied — only admin can login here');
// //         return;
// //       }
// //       localStorage.setItem('token', res.data.token);
// //       localStorage.setItem('role', res.data.role);
// //       localStorage.setItem('name', res.data.name || 'Admin');
// //       // redirect to admin
// //       navigate('/admin', { replace: true });
// //     } catch (err) {
// //       console.error(err);
// //       alert(err.response?.data?.message || 'Login failed — check credentials & server');
// //     }
// //   };

// //   return (
// //     <div className="container py-5">
// //       <div className="row justify-content-center">
// //         <div className="col-md-5 col-lg-4">
// //           <div className="card p-4 shadow-sm">
// //             <h4 className="mb-3 text-center">Admin Login</h4>
// //             <form onSubmit={submit}>
// //               <input
// //                 type="email"
// //                 className="form-control mb-2"
// //                 placeholder="Email"
// //                 value={email}
// //                 onChange={(e) => setEmail(e.target.value)}
// //                 required
// //               />
// //               <input
// //                 type="password"
// //                 className="form-control mb-3"
// //                 placeholder="Password"
// //                 value={password}
// //                 onChange={(e) => setPassword(e.target.value)}
// //                 required
// //               />
// //               <button className="btn btn-primary w-100">Login</button>
// //             </form>
// //             <div className="text-center mt-3">
// //               <small>
// //                 Don't have an admin account? <Link to="/signup">Signup</Link>
// //               </small>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, Link } from "react-router-dom";
// import "./Login.css";
// import logo from "../assets/WhatsApp Image 2025-12-05 at 13.19.29_68ae0406.jpg";
// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const submit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post("https://grocerrybackend.vercel.app/api/admin/login", {
//         email,
//         password,
//       });

//       if (!res.data || !res.data.token) {
//         alert("Login failed: Invalid response from server");
//         return;
//       }

//       if (res.data.role !== "admin") {
//         alert("Access Denied — only admin can login here");
//         return;
//       }

//       localStorage.setItem("token", res.data.token);
//       localStorage.setItem("role", res.data.role);
//       localStorage.setItem("name", res.data.name || "Admin");

//       navigate("/admin/users", { replace: true });
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || "Login failed — check credentials & server");
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="login-card">
//         <h2 className="login-title">Admin Login</h2>
//         <p className="login-subtitle">Welcome back! Please sign in to continue.</p>
//         <form onSubmit={submit} className="login-form">
//           <div className="input-group">
//             <input
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>

//           <div className="input-group">
//             <input
//               type="password"
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>

//           <button type="submit" className="login-btn">
//             Login
//           </button>
//         </form>

//         <div className="signup-link">
//           <p>
//             Don’t have an account?{" "}
//             <Link to="/signup" className="link">
//               Sign up
//             </Link>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, Link } from "react-router-dom";
// import "./Login.css";
// import loginImg from "../assets/WhatsApp Image 2025-12-05 at 13.19.29_68ae0406.jpg";

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const submit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post("https://grocerrybackend.vercel.app/api/admin/login", {
//         email,
//         password,
//       });

//       if (!res.data || !res.data.token) {
//         alert("Login failed: Invalid response from server");
//         return;
//       }

//       if (res.data.role !== "admin") {
//         alert("Access Denied — only admin can login here");
//         return;
//       }

//       localStorage.setItem("token", res.data.token);
//       localStorage.setItem("role", res.data.role);
//       localStorage.setItem("name", res.data.name || "Admin");

//       navigate("/admin/pricelist", { replace: true });
//     } catch (err) {
//       alert(err.response?.data?.message || "Login failed");
//     }
//   };

//   return (
//     <div className="login-wrapper">
//       {/* LEFT IMAGE SECTION */}
//       <div className="login-left">
//         <img src={loginImg} alt="Login Visual" className="login-image" />
//       </div>

//       {/* RIGHT FORM SECTION */}
//       <div className="login-right">
//         <div className="login-box">

//           <h2 className="login-title">Welcome Back 👋</h2>
//           <p className="login-subtitle">Admin Portal Access</p>

//           <form onSubmit={submit} className="login-form">

//             <div className="input-group">
//               <label>Email</label>
//               <input
//                 type="email"
//                 placeholder="Enter your email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//             </div>

//             <div className="input-group">
//               <label>Password</label>
//               <input
//                 type="password"
//                 placeholder="Enter your password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//             </div>

//             <button className="login-btn">Login</button>
//           </form>

//           <p className="signup-text">
//             Don’t have an account? <Link to="/signup">Sign Up</Link>
//           </p>

//         </div>
//       </div>
//     </div>
//   );
// }





// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, Link } from "react-router-dom";
// import loginImg from "../assets/WhatsApp Image 2025-12-05 at 13.19.29_68ae0406.jpg";

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const submit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post("https://grocerrybackend.vercel.app/api/admin/login", {
//         email,
//         password,
//       });

//       if (!res.data || !res.data.token) {
//         alert("Login failed: Invalid response from server");
//         return;
//       }

//       if (res.data.role !== "admin") {
//         alert("Access Denied — only admin can login here");
//         return;
//       }

//       localStorage.setItem("token", res.data.token);
//       localStorage.setItem("role", res.data.role);
//       localStorage.setItem("name", res.data.name || "Admin");

//       navigate("/admin/pricelist", { replace: true });
//     } catch (err) {
//       alert(err.response?.data?.message || "Login failed");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-white flex flex-col md:flex-row font-sans">
//       {/* Left Image Section */}
//       <div className="md:w-1/2 h-64 md:h-auto overflow-hidden bg-gradient-to-br from-blue-50 to-white">
//         <div className="relative h-full w-full">
//           <img 
//             src={loginImg} 
//             alt="Login Visual" 
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-white/60 md:bg-gradient-to-r md:from-transparent md:via-white/40 md:to-white/90"></div>
          
//           {/* Decorative elements */}
//           <div className="absolute top-6 left-6 flex items-center space-x-2">
//             <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center">
//               <span className="text-white font-bold text-lg">G</span>
//             </div>
//             <span className="text-blue-900 font-bold text-xl">GrocerryAdmin</span>
//           </div>
          
//           {/* <div className="absolute bottom-10 left-10 max-w-md">
//             <h1 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
//               Streamline Your Grocery Management
//             </h1>
//             <p className="text-blue-700/80 text-lg">
//               Access your admin dashboard to manage products, prices, and inventory efficiently.
//             </p>
//           </div> */}
//         </div>
//       </div>

//       {/* Right Form Section */}
//       <div className="md:w-1/2 flex items-center justify-center p-6 md:p-12 bg-gradient-to-b from-white to-blue-50">
//         <div className="w-full max-w-md">
//           {/* Header */}
//           <div className="text-center mb-10">
//             <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-100 mb-6">
//               <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"></path>
//               </svg>
//             </div>
//             <h2 className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h2>
//             <p className="text-gray-600">Sign in to your admin account</p>
//           </div>

//           {/* Form */}
//           <form onSubmit={submit} className="space-y-6">
//             {/* Email Field */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Email Address
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <svg className="h-5 w-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
//                   </svg>
//                 </div>
//                 <input
//                   type="email"
//                   placeholder="admin@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 outline-none"
//                 />
//               </div>
//             </div>

//             {/* Password Field */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Password
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <svg className="h-5 w-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
//                   </svg>
//                 </div>
//                 <input
//                   type="password"
//                   placeholder="Enter your password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 outline-none"
//                 />
//               </div>
//             </div>

//             {/* Remember Me & Forgot Password */}
//             <div className="flex items-center justify-between">
//               <div className="flex items-center">
//                 <input
//                   type="checkbox"
//                   id="remember"
//                   className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                 />
//                 <label htmlFor="remember" className="ml-2 block text-sm text-gray-700">
//                   Remember me
//                 </label>
//               </div>
//               <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-500 transition">
//                 Forgot password?
//               </a>
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-4 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 shadow-md hover:shadow-lg"
//             >
//               Sign In
//             </button>

//             {/* Admin Notice */}
//             <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
//               <div className="flex items-start">
//                 <div className="flex-shrink-0">
//                   <svg className="h-5 w-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//                   </svg>
//                 </div>
//                 <div className="ml-3">
//                   <h3 className="text-sm font-medium text-blue-900">Admin Access Only</h3>
//                   <div className="mt-2 text-sm text-blue-700">
//                     <p>This portal is restricted to authorized administrators only.</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </form>

//           {/* Sign Up Link */}
//           <div className="mt-8 text-center">
//             <p className="text-gray-600">
//               Don't have an admin account?{" "}
//               <Link to="/signup" className="font-semibold text-blue-600 hover:text-blue-500 transition">
//                 Request access
//               </Link>
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }







import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post("https://grocerrybackend.vercel.app/api/admin/login", {
        email,
        password,
      });

      if (!res.data || !res.data.token) {
        setError("Login failed: Invalid response from server");
        return;
      }

      if (res.data.role !== "admin") {
        setError("Access Denied — only admin can login here");
        return;
      }

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.role);
      localStorage.setItem("name", res.data.name || "Admin");

      navigate("/admin/pricelist", { replace: true });
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Login failed. Please check your credentials.";
      setError(errorMessage);
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen w-screen flex items-center justify-center p-4 bg-gradient-to-br from-blue-50 via-white to-gray-50 font-sans overflow-hidden">
      {/* Main Compact Container */}
      <div className="w-full max-w-sm mx-auto">
        
        {/* Logo Header */}
        <div className="flex flex-col items-center justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center p-1 mb-3 ring-2 ring-blue-100">
            <img 
              src={logo} 
              alt="GrocerryAdmin Logo" 
              className="w-full h-full object-cover rounded-full"
            />
          </div>
          <h1 className="text-xl font-bold text-gray-900 text-center">SG Ovearseas Admin</h1>
          <p className="text-gray-600 text-sm mt-1 text-center">Admin Portal</p>
        </div>

        {/* Compact Login Card */}
        <div className="bg-white rounded-xl shadow-lg p-5 border border-gray-100">
          
          {/* Form Header */}
          <div className="text-center mb-5">
            <h2 className="text-lg font-bold text-gray-900">Welcome Back</h2>
            <p className="text-gray-600 text-xs mt-1">Sign in to continue</p>
          </div>

          {/* Error Message */}
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg animate-fadeIn">
              <div className="flex items-center">
                <svg className="w-4 h-4 text-red-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-red-800 text-xs font-medium">{error}</span>
              </div>
            </div>
          )}

          {/* Compact Login Form */}
          <form onSubmit={submit} className="space-y-4">
            
            {/* Email Field */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">
                Email
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <input
                  type="email"
                  placeholder="admin@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  className="w-full text-sm pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none disabled:bg-gray-100"
                />
              </div>
            </div>

            {/* Password Field */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">
                Password
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  className="w-full text-sm pl-9 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none disabled:bg-gray-100"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  disabled={loading}
                >
                  {showPassword ? (
                    <svg className="h-4 w-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    </svg>
                  ) : (
                    <svg className="h-4 w-4 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Remember Me */}
            <div className="flex items-center">
              <input
                type="checkbox"
                id="remember"
                disabled={loading}
                className="h-3.5 w-3.5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label htmlFor="remember" className="ml-2 block text-xs text-gray-700 select-none">
                Keep me signed in
              </label>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm py-1.5 px-4 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-1 transition-all shadow hover:shadow-md active:scale-[0.99] disabled:opacity-70"
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <svg className="animate-spin h-4 w-4 mr-2 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  Signing in...
                </div>
              ) : (
                "Sign In"
              )}
            </button>

            {/* Admin Notice */}
            {/* <div className="mt-3 p-3 bg-blue-50 border border-blue-100 rounded-lg">
              <div className="flex items-start">
                <svg className="w-3.5 h-3.5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <div>
                  <h3 className="text-xs font-semibold text-blue-900">Admin Access</h3>
                  <p className="text-blue-700 text-xs mt-0.5">Authorized personnel only</p>
                </div>
              </div>
            </div> */}
          </form>

          {/* Sign Up Link */}
          <div className="mt-5 pt-4 border-t border-gray-200 text-center">
            <p className="text-gray-600 text-xs">
              Need access?{" "}
              <Link 
                to="/signup" 
                className="font-semibold text-blue-600 hover:text-blue-500 transition-colors text-xs"
              >
                Sign Up
              </Link>
            </p>
          </div>
        </div>

        {/* Compact Footer */}
        <div className="mt-4 text-center">
          <p className="text-gray-500 text-xs">
            © {new Date().getFullYear()} GrocerryAdmin
          </p>
        </div>
      </div>
    </div>
  );
}

